import Panes from './Panes';

export default Panes;
